import React, { useState } from "react";
import faqs from "./propertyLoanFaqs.json";

const categories = [
  ["all", "All"],
  ["basics", "Loan types"],
  ["elig", "Eligibility"],
  ["process", "Process"],
  ["cost", "Costs & risks"],
  ["trust", "Lenders & safety"],
];

export default function PropertyLoanFaq() {
  const [category, setCategory] = useState("all");
  const [query, setQuery] = useState("");
  const visible = faqs.filter(
    (faq) =>
      (category === "all" || faq.category === category) &&
      `${faq.question} ${faq.answer.replace(/<[^>]*>/g, " ")}`
        .toLowerCase()
        .includes(query.trim().toLowerCase()),
  );
  return (
    <section
      className="pl-faq"
      id="property-loan-faq"
      aria-labelledby="property-faq-heading"
    >
      <div className="pl-faq-head">
        <div>
          <small>Got questions?</small>
          <h2 id="property-faq-heading">Frequently Asked Questions</h2>
          <p>
            Everything you need to know about borrowing against your private
            property on SmartLend.
          </p>
        </div>
        <input
          type="search"
          aria-label="Search frequently asked questions"
          placeholder="Search questions…"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
      </div>
      <div className="pl-chips" aria-label="FAQ categories">
        {categories.map(([key, label]) => (
          <button
            type="button"
            key={key}
            className={category === key ? "is-active" : ""}
            aria-pressed={category === key}
            onClick={() => setCategory(key)}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="pl-faq-list">
        {visible.map((faq) => (
          <details
            className="pl-qa"
            key={faq.question}
            open={faq === faqs[0] ? true : undefined}
          >
            <summary>{faq.question}</summary>
            <div
              className="pl-answer"
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            />
          </details>
        ))}
        {!visible.length && (
          <p role="status" className="pl-empty">
            No matching questions. Try another search or category.
          </p>
        )}
      </div>
      <div className="pl-faq-foot">
        <div>
          <b>Still have a question?</b>
          <span>
            A property loan specialist can walk you through your options. No
            obligation.
          </span>
        </div>
        <a href="/contactus">Chat with a specialist</a>
      </div>
      <p className="pl-legal">
        *Indicative timelines and estimates only. SmartLend is a loan
        marketplace and is not a lender. Loan approval, amount, rates and fees
        are decided by each lending partner. Borrow responsibly: your property
        may be at risk if you do not keep up repayments.
      </p>
    </section>
  );
}
